import { render, staticRenderFns } from "./IconServicePoint.vue?vue&type=template&id=6edbbb9e&"
import script from "./IconServicePoint.vue?vue&type=script&lang=ts&"
export * from "./IconServicePoint.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports